module.exports = __webpack_public_path__ + "img/blog.5f6fe053.svg";